import { authRequest } from './index.js'

export async function get_material(material_id){
  let data
  await authRequest.get(
    '/materials/' + material_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    // console.log("🚀 ~ file: child.js:32 ~ retrieve_children ~ error:", error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_reading_materials(material_id){
  let data
  await authRequest.get(
    '/materials/' + material_id + '/reading_material'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}